import React from 'react';
import { FaFileCsv } from 'react-icons/fa';
import CargasFuente from '../../components/InversionesExterior/CargasFuente';

/**
 * Tarjeta Fintual: el CSV «dj1929_formato_sii» que Fintual entrega para la DJ 1929.
 * Su lector está en src/services/inversionesExterior/lectores/fintual.js
 */
const FintualPage = ({ token, id_company }) => (
    <CargasFuente
        token={token}
        idCompany={id_company}
        fuente="fintual"
        titulo="Fintual"
        icono={<FaFileCsv />}
        extensiones=".csv"
        ayuda={(
            <>
                Sube el CSV <strong>dj1929_formato_sii</strong> que Fintual entrega para la DJ 1929; el Excel del
                detalle de operaciones no se sube. TAXI solo cambia la relación 99 por 9: lo demás queda como lo manda
                Fintual, con avisos donde no calza con las instrucciones del SII. El archivo no se guarda.
            </>
        )}
    />
);

export default FintualPage;
